module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/cn/CREW_BOOK_NATIONAL_france_cn.d5898f56.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/crewBookNational/cn/CREW_BOOK_NATIONAL_france_cn.png
// module id = 1208
// module chunks = 16